import { useEffect, useState, type ReactElement } from 'react';

import { PageHelmet } from '../../components/PageHelmet';
import VideoBanner from '../../components/VideoBanner';
import ActionsSection1 from './Actions1';
import ActionsSection2 from './Actions2';
import AppsSection from './Apps';
import HealthSection from './Health';
import SpacesSection from './Spaces';
import YourPlanSection from './YourPlan';
import ImagePopup from './PopUp';
import axios from 'axios';

const HomePage = (): ReactElement => {
  const [campanha, setCampanha] = useState<any>({});

  const fetchCampanha = async () => {
    const baseUrl = process.env.REACT_APP_OG_API_URL;
    try {
      const response = await axios.get(`${baseUrl}/campanhas/ativos`);
      if (response.data.length === 0) return null;
      setCampanha(response.data[0]);
    } catch (error) {
      console.error('Erro ao buscar campanha:', error);
      return null;
    }
  };

  useEffect(() => {
    console.log('Fetching campanha...');
    fetchCampanha();
  }, []);

  return (
    <>
      <PageHelmet title="OdontoGroup | Saúde começa aqui" />

      <VideoBanner page="home" />
      <YourPlanSection />
      <ActionsSection1 />
      <SpacesSection />
      <AppsSection />
      <ActionsSection2 />
      <HealthSection />
      {campanha?.id_campanha && (
        <ImagePopup
          imageUrl={campanha.img_campanha}
          title={campanha.nome_campanha}
          linkUrl={campanha.link_campanha}
          imageAlt={campanha.nome_campanha}
        />
      )}
    </>
  );
};

export default HomePage;
